function PermissionsToSelectBox(permissions) {
	var selectedOptions = permissions.map(function (p) {			
		return {value: p.id.toString(), label: p.name}
	});		
	return selectedOptions;    
}
export default PermissionsToSelectBox;